function initTestimonialsSlider() {
  const grids = document.querySelectorAll('.customer-testimonials__grid');

  grids.forEach(grid => {
    if (grid.dataset.sliderInitialized === 'true') return;
    grid.dataset.sliderInitialized = 'true';

    const originalCards = Array.from(grid.querySelectorAll('.customer-testimonials__card'));
    if (originalCards.length === 0) return;

    // Calculate original set width
    let gap = parseInt(window.getComputedStyle(grid).gap) || 0;
    let singleSetWidth = 0;
    originalCards.forEach(c => { singleSetWidth += c.offsetWidth + gap; });

    // We must ensure the cloned width is large enough to cover the screen
    const containerWidth = grid.clientWidth;
    const clonesNeeded = Math.max(2, Math.ceil(containerWidth / singleSetWidth) + 1);

    grid.style.scrollBehavior = 'auto'; // Disable smooth scroll for initial setup

    // Clone to the right
    for (let i = 0; i < clonesNeeded; i++) {
      originalCards.forEach(card => {
        grid.appendChild(card.cloneNode(true));
      });
    }

    // Clone to the left
    for (let i = 0; i < clonesNeeded; i++) {
      originalCards.slice().reverse().forEach(card => {
        grid.insertBefore(card.cloneNode(true), grid.firstChild);
      });
    }

    // Now total sets = 1 (original) + 2 * clonesNeeded
    // We should start at the first original set.
    const startScrollPos = singleSetWidth * clonesNeeded;

    // Update gap correctly in case it changed after cloning
    setTimeout(() => {
      grid.scrollLeft = startScrollPos;
      
      let isDown = false;
      let startX;
      let scrollLeft;
      let autoScrollInterval;
      const isAutoScrollEnabled = grid.getAttribute('data-auto-scroll') === 'true';
      const scrollDelay = 3500; // 3.5 seconds

      const handleInfiniteScroll = () => {
        // Jump if we scrolled left by one full set
        if (grid.scrollLeft <= startScrollPos - singleSetWidth) {
          grid.style.scrollBehavior = 'auto';
          grid.scrollLeft += singleSetWidth;
        } 
        // Jump if we scrolled right by one full set (-1px for subpixel safety)
        else if (grid.scrollLeft >= startScrollPos + singleSetWidth - 1) {
          grid.style.scrollBehavior = 'auto';
          grid.scrollLeft -= singleSetWidth;
        }
      };

      grid.addEventListener('scroll', () => {
        if (!isDown) {
           handleInfiniteScroll();
        }
      });

      // Drag to scroll logic
      grid.addEventListener('mousedown', (e) => {
        isDown = true;
        grid.classList.add('customer-testimonials__grid--active');
        grid.style.scrollBehavior = 'auto'; // Instant drag
        startX = e.pageX - grid.offsetLeft;
        scrollLeft = grid.scrollLeft;
        pauseAutoScroll();
      });

      grid.addEventListener('mouseleave', () => {
        if (!isDown) return;
        isDown = false;
        grid.classList.remove('customer-testimonials__grid--active');
        handleInfiniteScroll();
        startAutoScroll();
      });

      grid.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        grid.classList.remove('customer-testimonials__grid--active');
        handleInfiniteScroll();
        startAutoScroll();
      });

      grid.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - grid.offsetLeft;
        const walk = (x - startX) * 1.5; // Drag sensitivity
        grid.scrollLeft = scrollLeft - walk;
        handleInfiniteScroll(); // Keep in bounds during drag
      });

      // Pause on hover
      grid.addEventListener('mouseenter', () => {
        pauseAutoScroll();
      });

      // Auto scroll logic
      function startAutoScroll() {
        if (!isAutoScrollEnabled) return;
        pauseAutoScroll(); // Clear any existing interval
        
        autoScrollInterval = setInterval(() => {
          grid.style.scrollBehavior = 'smooth';
          grid.scrollBy({ left: originalCards[0].offsetWidth + gap, behavior: 'smooth' });
        }, scrollDelay);
      }

      function pauseAutoScroll() {
        if (autoScrollInterval) {
          clearInterval(autoScrollInterval);
          autoScrollInterval = null;
        }
      }

      // Touch event handling for mobile
      grid.addEventListener('touchstart', () => {
        grid.style.scrollBehavior = 'auto'; // allow native scroll feel
        pauseAutoScroll();
      }, { passive: true });
      
      grid.addEventListener('touchend', () => {
        startAutoScroll();
      }, { passive: true });

      // Initialize auto scroll on load
      startAutoScroll();
    }, 50); // Tiny delay to allow DOM render calculation
  });
}

document.addEventListener('DOMContentLoaded', initTestimonialsSlider);
document.addEventListener('shopify:section:load', initTestimonialsSlider);
